var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.808 17.5767C19.0644 17.5767 20.8936 15.3995 20.8936 12.7137C20.8936 10.028 19.0644 7.85083 16.808 7.85083C14.5517 7.85083 12.7225 10.028 12.7225 12.7137C12.7225 15.3995 14.5517 17.5767 16.808 17.5767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8156 21.7101C24.0802 20.2513 22.6912 19.0355 20.8935 18.3061C20.4033 18.144 19.8313 18.144 19.4228 18.3871C18.6057 18.8734 17.7886 19.1166 16.808 19.1166C15.8275 19.1166 15.0104 18.8734 14.1933 18.3871C13.7848 18.225 13.2128 18.144 12.7225 18.3871C10.9249 19.1166 9.53584 20.3323 8.80045 21.7912C8.22848 22.8448 9.12729 24.0605 10.3529 24.0605H23.2631C24.4888 24.0605 25.3876 22.8448 24.8156 21.7101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.76543,
    y1: 9.10083,
    x2: 7.76543,
    y2: 14.9671,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.25102,
    y1: 11.4812,
    x2: 10.1856,
    y2: 11.4812,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1951,
    height: 23.0073,
    fill: "white",
    transform: "translate(1.59526 2.97046)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetail);
export default __webpack_public_path__ + "static/media/account-detail.692d77bd3c4cb66ae4511e62eb72682f.svg";
export { ForwardRef as ReactComponent };